import { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";

const SpinnerBlock = ({show, onlyBlur = false}) => {

    const [showSpinner, setShowSpinner ] = useState(show);

    useEffect(()=>{
        setShowSpinner(show);
    }, [show])

    return (
        (showSpinner) && (
        <div
            style={{
                position:'absolute',
                display:'flex',
                alignItems:'center',
                left:'0px',
                top:'0px',
                width:'100%',
                height:'100%',
                backdropFilter: 'blur(3px)',
                zIndex:999,
                borderRadius:'10px',
                cursor:'wait'

            }}>
            {!onlyBlur  && (
            <div className="text-center w-100">
                <Spinner animation="border" variant="primary" />
            </div>
            )}
            
        </div>)
    )
}

export default SpinnerBlock;